export default {
    coverage_details_title: "Coverage Details",
    coverage_details_no_details: "No Details",
    coverage_details_address: "Address",
    coverage_details_coordinates: "Coordinates",
    coverage_details_hdop: "HDop",
    coverage_details_heartbeat: "Heartbeat",
    coverage_details_installed: "Installed",
    coverage_details_rssi: "RSSI",
    coverage_details_pass: "Pass",
    coverage_details_fail: "Fail, Click to see the details",
    coverage_details_score: "Diagnostic Score",
    coverage_details_updated_on: "Diagnostic Updated On",
    coverage_details_update_diagnostic: "Update Diagnostic",
    coverage_details_diagnostic_details: "Diagnostic Details",

    coverage_details_input: "IMEI or Serial",
    coverage_details_imei: "IMEI",
    coverage_details_serial: "Serial",
    coverage_details_model: "Model",
    coverage_details_change: "Mark as RMA",
    coverage_details_no_devices_added: "No devices added",
    coverage_details_device_is_already_added: "The device is already added",
    coverage_details_device_has_not_been_found: "The device has not been found",
    coverage_details_this_feature_is_not_available: "This feature is not available",
    coverage_details_single_success_message: "The device has been marked as RMA",
    coverage_details_multiple_success_message: "The the devices has been marked as RMA",
    coverage_details_error_message: "Unable to mark as RMA due to an error",
    coverage_details_show_in_web: "Show In Web",
    coverage_details_number: "RMA Number",
    coverage_details_device_is_already_rma: "The device is already marked as RMA",
    coverage_details_device_is_already_refirbished: "The device is already refurbished",
    coverage_details_devices_is_already_rma: "There are devices already marked as RMA",
    coverage_details_devices_is_already_refirbished: "There are devices already refurbished",
    coverage_details_min_message: "RMA number must be at least 5 digits long"
}

